module.exports = __webpack_public_path__ + "img/bmp.7d584e08.svg";